var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FormHelperText, MenuItem, Select, styled, useTheme, } from '@mui/material';
import { Controller, useFormContext, } from 'react-hook-form';
import { COUNTRY_CODES } from 'hx-util';
import { hasFlag } from 'country-flag-icons';
import TextField from './TextField';
import { AiOutlinePlus } from 'react-icons/ai';
import classNames from 'classnames';
export function PhoneNumberInput(_a) {
    var _b;
    var control = _a.control, countrySelectProps = _a.countrySelectProps, textFieldProps = _a.textFieldProps, className = _a.className;
    var _c = useFormContext(), contextControl = _c.control, getFieldState = _c.getFieldState;
    var error = (_b = getFieldState(textFieldProps.name)) === null || _b === void 0 ? void 0 : _b.error;
    return (_jsxs("div", __assign({ className: classNames('grid', className) }, { children: [_jsxs("div", __assign({ className: "flex w-full gap-1" }, { children: [_jsx(CountryCodeSelect, __assign({}, countrySelectProps, { control: control || contextControl })), _jsx(TextField, __assign({ control: control || contextControl, className: "flex-1", hideError: true }, textFieldProps, { required: !!textFieldProps.rules.required }))] })), error && _jsx(FormHelperText, __assign({ error: true }, { children: error.message }))] })));
}
export default PhoneNumberInput;
var CountryCodeSelect = function (_a) {
    var control = _a.control, rules = _a.rules, name = _a.name, variant = _a.variant, label = _a.label, _b = _a.CountrySelectItem, CountrySelectItem = _b === void 0 ? DefaultCountrySelectItem : _b, _c = _a.shouldRenderCountry, shouldRenderCountry = _c === void 0 ? function (countryCode) { return true; } : _c;
    return (_jsx(Controller, { control: control, rules: rules, name: name, render: function (_a) {
            var _b = _a.field, onChange = _b.onChange, onBlur = _b.onBlur, value = _b.value, name = _b.name, ref = _b.ref, _c = _a.fieldState, isTouched = _c.isTouched, isDirty = _c.isDirty, error = _c.error, formState = _a.formState;
            return (_jsx(StyledSelect, __assign({ value: value || '+1', name: "country-code", onChange: onChange, onBlur: onBlur, variant: variant, label: label }, { children: COUNTRY_CODES.filter(shouldRenderCountry).map(function (countryCode, index) { return (_jsx(MenuItem, __assign({ value: countryCode.dialCode, className: "flex gap-4 w-fit-content" }, { children: _jsx(CountrySelectItem, { countryCode: countryCode }) }), "country-code-".concat(index))); }) })));
        } }));
};
var StyledSelect = styled(Select)({
    maxHeight: '48px',
    '& .MuiSelect-select': {
        display: 'flex',
        gap: '1rem',
        alignItems: 'center',
    },
});
var FlagImage = styled('img')({
    height: '1rem',
});
var DefaultCountrySelectItem = function (_a) {
    var countryCode = _a.countryCode;
    var theme = useTheme();
    return (_jsxs(_Fragment, { children: [hasFlag(countryCode.code) && (_jsx(FlagImage, { alt: "".concat(countryCode.name, " flag"), src: "https://purecatamphetamine.github.io/country-flag-icons/3x2/".concat(countryCode.code, ".svg") })), _jsxs("span", __assign({ className: "flex items-center" }, { children: [_jsx(AiOutlinePlus, { color: theme.palette.text.primary, size: ".75rem" }), _jsx("span", { children: countryCode.dialCode.replace('+', '') })] }))] }));
};
